<template>
    <div>
        <el-breadcrumb>
            <el-breadcrumb-item>交易活动：</el-breadcrumb-item>
            <el-breadcrumb-item>交易币种：{{configInfo.pair}}</el-breadcrumb-item>
            <el-breadcrumb-item>活动开始时间：{{configInfo.start ? configInfo.start.year : ''}}年 {{ configInfo.start ? configInfo.start.monthValue : ''}}月 {{configInfo.start ? configInfo.start.dayOfMonth : ''}}日 {{configInfo.start ? configInfo.start.hour : ''}}时 {{configInfo.start ? configInfo.start.minute : ''}} 分{{configInfo.start ? configInfo.start.second : ''}} 秒</el-breadcrumb-item>
            <el-breadcrumb-item>活动结束时间：{{configInfo.end ? configInfo.end.year : ''}}年 {{configInfo.end ? configInfo.end.monthValue : ''}}月 {{configInfo.end ? configInfo.end.dayOfMonth : ''}}日 {{configInfo.end ? configInfo.end.hour : ''}}时 {{configInfo.end ? configInfo.end.minute : ''}}分 {{configInfo.end ? configInfo.end.second : ''}}秒 </el-breadcrumb-item>
        </el-breadcrumb>
        <br>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="净买⼊量排行榜" name="purchases">
                <el-table :data="netPurchases">
                    <el-table-column prop="userId" label="用户ID"></el-table-column>
                    <el-table-column prop="amount" label="净买入量"></el-table-column>
                </el-table>
                <br>
                <el-pagination background layout="prev, pager, next" :total="totalPurchases" :page-size="25" :current-page="pageNo"
                               @current-change="changePage"></el-pagination>
            </el-tab-pane>
            <el-tab-pane label="交易量排行榜" name="volume">
                <el-table :data="tradeVolume">
                    <el-table-column prop="userId" label="用户ID"></el-table-column>
                    <el-table-column prop="amount" label="净买入量"></el-table-column>
                </el-table>
                <br>
                <el-pagination background layout="prev, pager, next" :total="totalVolume" :page-size="25" :current-page="pageNo"
                               @current-change="changePage"></el-pagination>
            </el-tab-pane>
            <el-tab-pane label="净充值数量排行榜" name="deposit">
                <el-table :data="netDeposit">
                    <el-table-column prop="userId" label="用户ID"></el-table-column>
                    <el-table-column prop="amount" label="净买入量"></el-table-column>
                </el-table>
                <br>
                <el-pagination background layout="prev, pager, next" :total="totalDeposit" :page-size="25" :current-page="pageNo"
                               @current-change="changePage"></el-pagination>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import '../store';
    import {mapState, mapActions} from 'vuex';

    export default {
        name: "rankActivity",
        data() {
            return {
                activeName: 'purchases',
                pageNo: 1,
            }
        },

        computed: {
            ...mapState('tradeStatistic', ['netPurchases', 'tradeVolume', 'netDeposit', 'totalPurchases', 'totalVolume', 'totalDeposit','configInfo'])
        },

        methods: {
            ...mapActions('tradeStatistic', ['getNetDeposit', 'getNetPurchases', 'getTradeVolume','findConfig']),
            handleClick() {
                this.changePage(1);
            },
            changePage(pageNo) {
                switch (this.activeName) {
                    case "purchases":
                        this.getNetPurchases(pageNo);
                        break;
                    case "volume":
                        this.getTradeVolume(pageNo);
                        break;
                    case "deposit":
                        this.getNetDeposit(pageNo);
                        break;
                    default:
                }
            }
        },

        created() {
            this.getNetPurchases(1);
            this.findConfig();
        }
    }
</script>

<style scoped>

</style>